import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchEventInfo({ id, callbacks }) {
  try {
    const response = yield call(api.fetchEventInfo, id);
    yield put(Actions.fetchEventInfoSuccess(response?.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchEventInfoFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchEvents() {
  yield takeLatest(Actions.FETCH_EVENT_INFO_REQUEST, fetchEventInfo);
}

export default function* list() {
  yield all([fork(watchFetchEvents)]);
}
